/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { PhoneCommunicationDto } from '../../../../../apps/myprofile-ui/src/app/services/phone/phone.service'

@Injectable({
  providedIn: 'root',
})
export class MyProfilePhoneFormService {
  private formBuilder = inject(UntypedFormBuilder)

  isLastMobileNumber(mobile: PhoneCommunicationDto, phones: PhoneCommunicationDto[]): boolean {
    if (mobile.phoneType != 'mobile') {
      return false
    }
    // You are not allowed to delete the last mobile number of your account
    const mobiles = phones.filter((phone: PhoneCommunicationDto) => phone.phoneType === 'mobile')
    return mobiles && mobiles.length === 1
  }

  public createDefaultPhoneForm() {
    return this.formBuilder.group({
      id: null,
      isVerified: false,
      isStandard: false,
      usage: 'home',
      phoneType: 'mobile',
      number: [undefined, Validators.required],
    })
  }

  public createPrefilledPhoneForm(selectedPhone: PhoneCommunicationDto, disabled = false) {
    return this.formBuilder.group({
      id: selectedPhone.id,
      isVerified: selectedPhone.isVerified,
      isStandard: { value: selectedPhone.isStandard, disabled },
      usage: selectedPhone.usage,
      phoneType: selectedPhone.phoneType,
      number: [selectedPhone.number, Validators.required],
    })
  }

  getStringWithoutWhitespaces(input: string): string {
    const reg = new RegExp('[^0-9+]', 'g')
    return input.replace(reg, '')
  }

  public preparePhonePayload(formGroup: UntypedFormGroup) {
    const phoneNumber: string = formGroup?.get('number')?.value
    formGroup.patchValue({ number: this.getStringWithoutWhitespaces(phoneNumber) })

    const result: any = {}

    Object.entries(formGroup.controls).forEach(([ctrlKey, ctrlValue]) => {
      if (ctrlValue instanceof UntypedFormGroup) {
        Object.entries(ctrlValue.value).forEach(([key, value]) => {
          result[key] = value
        })
      } else {
        result[ctrlKey] = ctrlValue.value
      }
    })

    return result
  }
}
